import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { ADMIN_ASSISTANT_PREVIEW_KEY, NO_ASSISTANT, ASSISTANT_CHANGED_EVENT, getAssistant, type AssistantDef } from "@/lib/assistants";

export interface MyAssistant { def: AssistantDef | null; displayName: string }

/** Asistente elegido por el usuario (perfil), o null si aún no ha elegido. */
export function useMyAssistant(): MyAssistant | null {
  const [state, setState] = useState<MyAssistant | null>(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      // Vista «Visitante» del administrador: un visitante no tiene avatar.
      let guestPreview = false;
      try { guestPreview = localStorage.getItem("rl-admin-guest-preview") === "1"; } catch { /* sin almacenamiento */ }
      if (!session || guestPreview) { if (alive) setState(null); return; }
      const { data } = await supabase.from("profiles").select("assistant_id, assistant_name").eq("user_id", session.user.id).maybeSingle();
      const pv = sessionStorage.getItem(ADMIN_ASSISTANT_PREVIEW_KEY);
      if (pv) {
        const { data: isAdmin } = await supabase.rpc("has_role", { _user_id: session.user.id, _role: "admin" });
        if (isAdmin) { const d = getAssistant(pv); if (alive) setState(d ? { def: d, displayName: d.name } : pv === NO_ASSISTANT ? { def: null, displayName: "Sara" } : null); return; }
      }
      const def = getAssistant(data?.assistant_id);
      if (alive) { const n = data?.assistant_name?.trim(); setState(def ? { def, displayName: n || def.name } : n ? { def: null, displayName: n } : null); }
    };
    void load();
    window.addEventListener(ASSISTANT_CHANGED_EVENT, load);
    return () => { alive = false; window.removeEventListener(ASSISTANT_CHANGED_EVENT, load); };
  }, []);
  return state;
}
